<template>
<div>

<DialogBox :settings="settings" save-on-enter @save="">

    <div class="pa-4">
        <GenericList :items="items" @click="listItemClicked" />
    </div>

</DialogBox>

</div>
</template>

<script>
import DialogBox from '../ui-elements/DialogBox'
import GenericList from '../ui-elements/GenericList'


export default {
    data() {
        return {
            value: ''
        }
    },
    components: {
        DialogBox,
        GenericList
    },

    props: {
        items: Array,
        settings: Object,
        clickHandler: Function,
        // Can have: title, visible, description, default
    },

    computed: {

        
    },


    methods: {
        listItemClicked(item) {
            console.log('listItemClicked', item)
            this.clickHandler(item)
        },
        initialiseDialog() {
            if(this.settings.default)
                this.value = this.settings.default
            setTimeout(() => {
                //this.$refs.focus.focus()
            },500)
        }

    },

    created() {
        
    }
}
</script>

<style scoped>
.blue-select {
    border:solid 1px transparent;
}
.blue-select.selected {
    /* background-color: rgb(187, 222, 255); */
    background-color: #E3F2FD;
    border: solid 1px rgb(112, 184, 255);
    box-shadow: 0 0 5px rgb(48, 132, 216);
}
   
</style>




// WEBPACK FOOTER //
// GenericListDialog.vue?329945eb